export const emailCheck: any =
 /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const gstCheck: any =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
export const panCheck: any = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
export const phoneCheck: any = /^[6-9]\d{9}$/;
export const passwordCheck: any = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const licenseCheck: any = /^[A-Z0-9\s]{10,20}$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&^_-])[A-Za-z\d@$!%*?#&^_-]{8,12}$/;